/*
  CC 2026-09-24 — "Weiterlesen" fuer lange Produktbeschreibungen

  Kuerzt die Beschreibung in sections/product-details.liquid nur, wenn sich das
  lohnt: erst ab --cc-schwelle gerenderter Hoehe, dann auf --cc-kappe (beides in
  section-product-details.css, je Breakpoint). Kurze Texte bleiben unveraendert —
  niemand soll klicken, um drei weitere Zeilen zu sehen.

  Der Text bleibt vollstaendig im DOM (SEO, Browser-Suche). Ohne JS keine Kuerzung.

  Messung: zwei Custom Events ueber Shopify.analytics.publish. Sie landen nur in
  GA4, wenn im Admin ein Custom Pixel sie abonniert (Code: docs/audit/
  2026-09-24-pdp-weiterlesen.md). Ohne Pixel passiert nichts.
    carpcenter:weiterlesen_gesehen        Schalter war sichtbar
    carpcenter:beschreibung_aufgeklappt   aufgeklappt (hoechstens einmal je Seitenaufruf)
  Beide tragen `kernargumente` (ja/manuell/nein: stand "Das Wichtigste" auf der Seite,
  snippets/cc-kernargumente.liquid); das Aufklappen zusaetzlich `ausloeser`
  (schalter/link/fokus). "Alle Details" in der Box klappt ueber oeffnen('link') auf.
  Auswertung: docs/audit/2026-09-24-pdp-weiterlesen.md
*/
(() => {
  if (customElements.get('cc-beschreibung')) return;

  const melden = (name, daten) => {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, daten);
      }
    } catch (e) { /* Tracking darf die Seite nie stoeren */ }
  };

  class CcBeschreibung extends HTMLElement {
    connectedCallback() {
      this.inhalt = this.querySelector('.product__description');
      this.schalter = this.querySelector('.cc-beschreibung__schalter');
      if (!this.inhalt || !this.schalter) return;

      this.offen = false;
      this.gekuerzt = false;
      this.desktop = window.matchMedia('(min-width: 750px)');

      this.schalter.addEventListener('click', () => this.umschalten());
      // Tab-Fokus auf einen Link im abgeschnittenen Teil: aufklappen statt unsichtbar fokussieren
      this.inhalt.addEventListener('focusin', () => this.oeffnen('fokus'));
      this.desktop.addEventListener('change', () => this.pruefen());
      // Webfonts/Bilder koennen die Hoehe nach dem ersten Messen noch aendern
      window.addEventListener('load', () => this.pruefen(), { once: true });

      this.pruefen();
    }

    pxAus(variable) {
      const wert = parseFloat(getComputedStyle(this).getPropertyValue(variable));
      const root = parseFloat(getComputedStyle(document.documentElement).fontSize);
      return wert * root;
    }

    pruefen() {
      if (this.offen) return;
      // scrollHeight liefert auch im gekuerzten Zustand die volle Inhaltshoehe
      this.hoehe = this.inhalt.scrollHeight;
      this.gekuerzt = this.hoehe > this.pxAus('--cc-schwelle');
      this.classList.toggle('is-gekuerzt', this.gekuerzt);
      this.schalter.hidden = !this.gekuerzt;
      if (this.gekuerzt) this.sichtbarkeitBeobachten();
    }

    daten() {
      return {
        produkt: this.dataset.produkt,
        zeichen: this.inhalt.textContent.trim().length,
        hoehe_px: this.hoehe,
        geraet: this.desktop.matches ? 'desktop' : 'mobil',
        kernargumente: document.querySelector('[data-cc-kernargumente]')?.dataset.ccQuelle || 'nein',
      };
    }

    sichtbarkeitBeobachten() {
      if (this.beobachter || !('IntersectionObserver' in window)) return;
      this.beobachter = new IntersectionObserver((eintraege) => {
        if (!eintraege.some((e) => e.isIntersecting)) return;
        melden('carpcenter:weiterlesen_gesehen', this.daten());
        this.beobachter.disconnect();
      });
      this.beobachter.observe(this.schalter);
    }

    oeffnen(ausloeser) {
      if (this.gekuerzt && !this.offen) this.umschalten(ausloeser);
    }

    umschalten(ausloeser = 'schalter') {
      this.offen = !this.offen;
      this.classList.toggle('is-offen', this.offen);
      this.schalter.setAttribute('aria-expanded', String(this.offen));
      this.schalter.querySelector('[data-text-zu]').hidden = this.offen;
      this.schalter.querySelector('[data-text-offen]').hidden = !this.offen;

      if (this.offen) {
        if (!this.gemeldet) {
          melden('carpcenter:beschreibung_aufgeklappt', { ...this.daten(), ausloeser });
          this.gemeldet = true;
        }
        return;
      }
      // Beim Zuklappen nicht irgendwo unterhalb des Texts stehen bleiben
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start' });
    }
  }

  customElements.define('cc-beschreibung', CcBeschreibung);

  // "Alle Details" in der Box unter dem Warenkorb-Button: aufklappen, dann zum Abschnitt
  // springen (nach dem Aufklappen, weil sich die Hoehe aendert). Ohne Kuerzung nur Sprung.
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-cc-details-link]');
    const beschreibung = link && document.querySelector('cc-beschreibung');
    if (!beschreibung || typeof beschreibung.oeffnen !== 'function') return;
    beschreibung.oeffnen('link');
    const ziel = document.querySelector(link.getAttribute('href'));
    if (!ziel) return;
    e.preventDefault();
    ziel.scrollIntoView({ block: 'start' });
  });
})();
